import { render, staticRenderFns } from "./filtersResetButton.vue?vue&type=template&id=4204c4c2&scoped=true"
import script from "./filtersResetButton.vue?vue&type=script&lang=js"
export * from "./filtersResetButton.vue?vue&type=script&lang=js"
import style0 from "./filtersResetButton.vue?vue&type=style&index=0&id=4204c4c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204c4c2",
  null
  
)

export default component.exports